import axios from "axios";
import { Sentry } from "./sentry";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "http://127.0.0.1:8000/api",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const isFormData =
      typeof FormData !== "undefined" && config.data instanceof FormData;
    if (isFormData) {
      delete config.headers["Content-Type"];
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    config.headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
    config.headers["Pragma"] = "no-cache";
    config.headers["Expires"] = "0";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const message = error.response?.data?.message ?? "";
    const url = error.config?.url ?? "";

    // Auth endpoints (/signin, /login, /signup, etc.) manage their own 401/422 credential and validation errors
    const isAuthRequest =
      url.includes("/signin") ||
      url.includes("/login") ||
      url.includes("/signup") ||
      url.includes("/forgot-password") ||
      url.includes("/reset-password");

    // Only force-logout on genuine token expiry on authenticated routes:
    // status 401 AND not an unauthenticated auth request
    const isAuthError =
      !isAuthRequest &&
      status === 401 &&
      typeof message === "string" &&
      (message.toLowerCase().includes("unauthenticated") ||
        message.toLowerCase().includes("unauthorized") ||
        message.toLowerCase().includes("token"));

    if (isAuthError) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    if (status >= 500) {
      Sentry.captureException(error, {
        extra: { url: error.config?.url, status, data: error.response?.data },
      });
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
